import { OnLoadAction } from '@/types/action'
import { CONSULTATION_TYPE } from '@/types/consultation'
import { Modal } from '@/types/modal'
import { StepConditionalRoute } from '@/types/route'
import { BACK_TYPE, Step } from '@/types/step'

export enum MODULE_TYPE {
  DEFAULT = 'default',
  CONSULTATION = 'consultation'
}

export type DefaultModule = {
  type: MODULE_TYPE.DEFAULT
  modals?: Record<string, Modal> // Modals of the module
}

export type ConsultationModule = {
  type: MODULE_TYPE.CONSULTATION
  consultationType: CONSULTATION_TYPE
  backButton?: BACK_TYPE // Default is no back button
}

export type Module = {
  id: string
  name: string

  steps: Record<string, Step> // Steps of the module
  initialSteps: StepConditionalRoute[] // Initial step to be shown

  onLoadActions?: OnLoadAction[] // Actions to be executed when the module is loaded
} & (DefaultModule | ConsultationModule)
